var map = {
	"./DigifondsGefoerdert.png": 89055,
	"./Hausthemen_Bild.png": 9003,
	"./TamaraEhs_logo.png": 5780,
	"./Teilen_ICON.svg": 86537,
	"./cc-by-sa.svg": 73356,
	"./decidim-logo-mobile.svg": 43943,
	"./digi_logo.svg": 70665,
	"./digi_logo_txt.svg": 18555,
	"./mitgestalten-logo.png": 71758,
	"./realitylab_logo.png": 36269
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 48999;